import React from 'react';
import styled from 'styled-components';
import { TextInput, IconButtonWrapper } from '@prosolve/common-components-ui';
import { FaRegTrashAlt } from 'react-icons/fa';
import AssessmentNamePicker from './AssessmentNamePicker';
import ModNamePicker from './ModNamePicker';

const RangeWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  flex-wrap: wrap;
  row-gap: 10px;
  padding: 10px;
  border: 1px solid #dedede;
  border-radius: 5px;
  background: #fafafa;
`

const FieldLabel = styled.div`
  font-size: 14px;
  color: #565656;
`

const clampPercent = (value) => {
  if (value === '' || value === undefined) return '';
  const num = Number(value);
  if (Number.isNaN(num)) return '';
  return Math.max(0, Math.min(100, num));
}

export default ({
  range = {},
  assessmentNames = [],
  modsByAssessment = {},
  currentAssessmentName,
  onChange,
  onDelete,
  isReadOnly
}) => {
  const { minPercent = '', maxPercent = '', followupAssessmentName = '', followupAssessmentMod = '' } = range;

  const targetModOptions = modsByAssessment[followupAssessmentName] || [];

  return (
    <RangeWrapper>
      <FieldLabel>{'From'}</FieldLabel>
      <TextInput
        type='number'
        min={0}
        value={String(minPercent)}
        onChange={(value) => {
          const clamped = clampPercent(value);
          if (String(clamped) !== String(minPercent)) {
            onChange({ ...range, minPercent: clamped })
          }
        }}
        width='70px'
        style={{ padding: '10px 8px', textAlign: 'center' }}
        isMobileView={false}
        disabled={isReadOnly}
      />
      <FieldLabel>{'% to'}</FieldLabel>
      <TextInput
        type='number'
        min={0}
        value={String(maxPercent)}
        onChange={(value) => {
          const clamped = clampPercent(value);
          if (String(clamped) !== String(maxPercent)) {
            onChange({ ...range, maxPercent: clamped })
          }
        }}
        width='70px'
        style={{ padding: '10px 8px', textAlign: 'center' }}
        isMobileView={false}
        disabled={isReadOnly}
      />
      <FieldLabel>{'% send the student to'}</FieldLabel>
      <AssessmentNamePicker
        value={followupAssessmentName}
        assessmentNames={assessmentNames}
        excludeName={currentAssessmentName}
        emptyText='Select an assessment...'
        onChange={(name) => onChange({ ...range, followupAssessmentName: name, followupAssessmentMod: '' })}
        disabled={isReadOnly}
      />
      {
        Boolean(targetModOptions.length) &&
        <>
          <FieldLabel>{'with mod'}</FieldLabel>
          <ModNamePicker
            value={followupAssessmentMod}
            modOptions={targetModOptions}
            onChange={(mod) => onChange({ ...range, followupAssessmentMod: mod })}
            disabled={isReadOnly}
          />
        </>
      }
      <div style={{ flex: 1 }} />
      {
        !isReadOnly &&
        <IconButtonWrapper onClick={onDelete} title='Remove range'>
          <FaRegTrashAlt style={{ color: '#565656' }} />
        </IconButtonWrapper>
      }
    </RangeWrapper>
  )
}
